<script>
	import formBase from '@_system/components/base/form.vue'
	import jindieform from '../costorder/jindie/form.vue'
	export default {
		extends: formBase,
		name: 'collectionsupplierForm',
		props: {

		},
		data() {
			return {
				formextardata:{},
				maindata:null,
				tabledata:[],
				jindierequire:null
			}

		},
		render(h) {
			this.$slots.plug = [
				<jindieform ref = "jindieform" maindata={this.maindata} tabledata={this.tabledata} jindierequire={this.jindierequire} onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,	
			]
			return formBase.render.call(this, h)
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeSubmit(formData, next) {
				let diffamount = this.fApi.getValue('diffamount')?this.fApi.getValue('diffamount'):0
				if(diffamount != 0){
					this.$message.error('差额不为0')
					return
				}			
				
				formData.supplierid = this.formextardata.supplierid
				formData.supplierwlnid = this.formextardata.supplierwlnid
				formData.jindierequire = formData.jindierequire?JSON.parse(formData.jindierequire):null
				//console.log(formData)
				next()
			},
			beforeRender(sourceData) {
				sourceData.jindierequire = sourceData.jindierequire?JSON.stringify(sourceData.jindierequire):null
			},
			serialIdButton(){
				let serialId = this.fApi.getValue('serialId')
				if(!serialId){
					this.$message.error('请填写支付流水ID')
					return
				}
				this.loading = true
				this.$api.collectionsupplier.getflowinfo({
					serialId:serialId,
				}).then((res)=>{
					this.fApi.setValue('amount',res.amt)
					this.fApi.setValue('collection_time',res.transTime * 1000)
					this.fApi.setValue('account',res.bankAcc)
					this.loading = false
				},()=>{
					this.loading = false
				})
			},
			jindierequireButton(){
				let jindietype = this.fApi.getValue('jindietype')
				if(!jindietype){
					this.$message.error('请选择星空模块')
					return
				}
				let bankAcc = null
				window.systemData.emun.forEach((item) => {
					if (item.id === this.fApi.getValue('account')) {
						bankAcc = item.alias
					}
				})
				
				let maindata = {}
				maindata.bankAcc = bankAcc
				maindata.jindietype = this.fApi.getValue('jindietype')
				maindata.supplierwlnid = this.sourceData.supplierwlnid
				console.log(maindata)
				let $son_collectionsupplier_costorder = this.fApi.el('$son_collectionsupplier_costorder')
				let table = $son_collectionsupplier_costorder.getGrid()
				let fullData = table.getTableData().fullData
				let costordertype = window.systemData.emun.filter((item)=>{
					return item.field == 'costordertype'
				})
				let tabledata = fullData.map((item)=>{
					let costordertypecode = null
					let target = costordertype.find((_item)=>{
						return _item.id == item.costordertype[item.costordertype.length - 1]
					})
					if(target && target.code){
						costordertypecode = target.code.split('/')[0]
					}
					return {
						id:item.id,
						costordertype:window.systemMethods.getEmunValue('costordertype',item.costordertype),
						costordertypecode:costordertypecode,
						costamount:item.costamount,
						businessdepartmentid:item.businessdepartmentid,
						FEXPENSEDEPTID_E:null,
						FCOSTID:null,
						FSETTLETYPEID:null,
						FPURPOSEID:null,
						F_SXTN_DFKM:null,
						F_SXTN_ZZJG:null,
					}
				})
				this.tabledata = tabledata.filter((item)=>{
					return item.id
				})
				this.maindata = maindata
				if(!tabledata.length){
					this.$message.error('未添加费用明细')
					return
				}
				//console.log(tabledata)
				this.jindierequire = this.fApi.getValue('jindierequire')
				this.$nextTick(()=>{
					this.$refs.jindieform.modal_show()
				})
				
			},
			jindieformSuccess(e){
				this.fApi.setValue('jindierequire',e.data)
				this.fApi.setValue('jindiestaffid',this.$store.state.system.user.id)
			},
			jindieformClear(){
				this.fApi.setValue('jindierequire',null)
			},
			
			
			beforeInit(next){
				next()
			},
			regestEvent(){
				let $son_collectionsupplier_purchase = this.fApi.el('$son_collectionsupplier_purchase')
				$son_collectionsupplier_purchase.notice = `
					<span style="margin-right:10px;color:#F56C6C">未入库填【CD】</span>		
				`
				let $son_collectionsupplier_purchaseoutstockbill = this.fApi.el('$son_collectionsupplier_purchaseoutstockbill')
				$son_collectionsupplier_purchaseoutstockbill.notice = `
					<span style="margin-right:10px;color:#F56C6C">已入库填【CT】</span>		
				`
				let $son_collectionsupplier_costorder = this.fApi.el('$son_collectionsupplier_costorder')
				$son_collectionsupplier_costorder.notice = `
					<span style="margin-right:10px;color:#F56C6C">差额填费用【正数为收入 负数为支出 费用项不会选咨询财务】</span>		
				`
			},
			afterGet(sourceData){
				this.formextardata = {
					supplierid:sourceData.id,
					supplierwlnid:sourceData.supplierwlnid
				}
			},
			afterBoxSubmit(e){
				this.formextardata = {}
				if(e.data){
					this.formextardata = {
						supplierid:e.data.id,
						supplierwlnid:e.data.wlnid
					}
				}
			},
			
			tableDataLoad(){
				this.comoutediffamount()
			},
			

			
			tableAdd(e) {
				console.log(this.formextardata)
				let supplierwlnid = this.formextardata.supplierwlnid
				if(!supplierwlnid){
					this.$message.error('请选择供应商')
					return
				}
				if(e.moduleName == 'collectionsupplier_costorder'){
					e.next()
					return
				}
				let message = '销售订单号'
				let title = '输入'
				let option = {
					distinguishCancelAndClose: true,
					confirmButtonText: '确定',
					cancelButtonText: '暂无',
					closeOnClickModal: false
				}
				if(e.moduleName == 'collectionsupplier_purchase'){
					message = '采购订单'
				}
				if(e.moduleName == 'collectionsupplier_purchaseoutstockbill'){
					message = '采购退货单'
				}
				if(this.device!='pc'){
					option.beforeClose = (action, done)=>{
						this.alterCheckOrder(e,action, null, done)
					}
				}else{
					option.beforeClose = (action, instance, done)=>{
						this.alterCheckOrder(e,action, instance, done)
					}
				}
				this.$prompt(message, title, option).then(() => {
					e.next()
					this.$nextTick(() => {
						this.comoutediffamount()
					})
				}).catch(() => {

				})
			},
			alterCheckOrder(e,action, instance, done){
				if (action == 'cancel') {
					done()
				}
				if (action == 'close') {
					e.obj = null
					done()
				}
				if (action == 'confirm') {
					this.loading = true
					if(instance){
						if(e.moduleName == 'collectionsupplier_purchase'){
							this.$api.collectionsupplier.purchaseQuery({
								billCode:instance.inputValue,
								supplierwlnid:this.formextardata.supplierwlnid
							}).then((res)=>{
								if(res){
									e.obj = [{
										billCode:res.billCode,
										amount:res.sum,
										supplierName:res.supplierName
									}]
								}else{
									e.obj = null
								}
								this.loading = false
								done()
							},()=>{
								this.loading = false
							})
						}
						if(e.moduleName == 'collectionsupplier_purchaseoutstockbill'){
							this.$api.collectionsupplier.queryPurchaseStockBill({
								stockCode:instance.inputValue,
								supplierwlnid:this.formextardata.supplierwlnid
							}).then((res)=>{
								if(res){
									e.obj = [{
										stockCode:res.stockCode,
										amount:res.sum,
										supplierName:res.supplierName
									}]
								}else{
									e.obj = null
								}
								this.loading = false
								done()
							},()=>{
								this.loading = false
							})
						}
					}else{
						this.$message.error('请输入单号')
					}
				}
			},
			ordercodeButton(){
				//console.log(this.fApi.getValue('amount'),this.fApi.getValue('orderamount'))
				let billCode = this.fApi.getValue('ordercode')
				this.loading = true
				this.$api.collectionsupplier.checkrelationorder({billCode:billCode}).then((res)=>{
					this.loading = false
					this.supplierwlnid = res.supplierID						
					this.fApi.setValue('suppliername',res.supplierName)
					this.fApi.setValue('orderamount',res.sum)
				},()=>{
					this.supplierwlnid = null
					this.fApi.setValue('suppliername',null)
					this.fApi.setValue('orderamount',null)
					this.loading = false
				})
				this.comoutediffamount()
			},
			tableInsert() {				
				this.comoutediffamount()
			},
			tablefieldChange(){
				this.comoutediffamount()
			},
			aftertabledelete() {
				this.comoutediffamount()
			},
			comoutediffamount(){
				let amount = this.fApi.getValue('amount')?this.fApi.getValue('amount'):0
				let purchasefullData = this.fApi.el('$son_collectionsupplier_purchase').getTableData().fullData
				let purchaseoutstockbillfullData = this.fApi.el('$son_collectionsupplier_purchaseoutstockbill').getTableData().fullData
				let costorderfullData = this.fApi.el('$son_collectionsupplier_costorder').getTableData().fullData
				//let totalamount = 0
				let purchaseamount = this.$Lodash.sumBy(purchasefullData,(item)=>{
					return item.amount?parseFloat(item.amount):0
				})
				let purchaseoutstockbillamount = this.$Lodash.sumBy(purchaseoutstockbillfullData,(item)=>{
					return item.amount?parseFloat(item.amount):0
				})
				let costamount = this.$Lodash.sumBy(costorderfullData,(item)=>{
					return item.costamount?parseFloat(item.costamount):0
				})
				
				if(costamount > 0){
					this.fApi.setValue('jindietype','AP_REFUNDBILL')
				}else{
					this.fApi.setValue('jindietype','AP_PAYBILL')
				}
				this.fApi.setValue('totalamount',purchaseamount + purchaseoutstockbillamount + costamount)
				this.fApi.setValue('diffamount',amount - purchaseamount - purchaseoutstockbillamount - costamount)
				
			}
		},
		components: {

		}
	}
</script>
